import {Component, OnInit} from '@angular/core';
import {
  ColDef,
  GetDataPath,
  GetRowNodeIdFunc,
  GridApi,
  GridReadyEvent,
  ICellRendererComp,
  ICellRendererParams,
  RowNode,
  SelectCellEditor,
} from 'ag-grid-community';
import 'ag-grid-enterprise';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {DownloadButtonRendererComponent} from './download-renderer.component';
import * as FileSaver from 'file-saver';
import {AwsSimpleServiceService} from '../../services/aws-s3/aws-simple-service.service';
import {AlertService} from '../../services/alert/alert.service';
import {LoadingService} from '../../services/loading/loading.service';
import moment from 'moment';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import { S3AdminPortalAuditTrailComponent } from '../s3-admin-portal-audit-trail/s3-admin-portal-audit-trail.component';

declare var window: any;

@Component({
    selector: 'app-s3-admin-portal',
    templateUrl: './s3-admin-portal.component.html',
    styleUrls: ['./s3-admin-portal.component.css'],
    standalone: false
})
export class S3AdminPortalComponent implements OnInit {
  key: String | undefined;
  private gridApi!: GridApi;
  fileUpload: File | undefined;
  s3protalFormControl!: UntypedFormGroup;
  fileToUpload: File | null = null;
  public rowSelection: string = 'single';
  public defaultColDef: ColDef = {
    flex: 1,
    filter: true,
    sortable: true,
    resizable: true,
  };
  bsModalRef: BsModalRef;
  public autoGroupColumnDef: ColDef = {
    headerName: 'Files',
    minWidth: 330,
    cellRendererParams: {
      checkbox: false,
      suppressCount: true,
      innerRenderer: getFileCellRenderer(),
    },
  };
  // public rowData: any[] | null = getData();
  public rowData: any;
  public groupDefaultExpanded = -1;

  constructor(private awsSimpleServiceService: AwsSimpleServiceService,
              private fb: UntypedFormBuilder, private alertService: AlertService,
              private loader: LoadingService, private modalService: BsModalService) {
  }

  ngOnInit(): void {
    this.getData();
    this.createForm();
  }

  viewAuditTrial(){
    this.loader.show();
    const profileName = "HS Test";
    this.awsSimpleServiceService.getAuditTrailListForS3Portal().subscribe(data => {
      if (data) {
          const auditTrailLogList = data;
          const initialState: any = {
            auditTrailLogList: auditTrailLogList,
            profile: profileName
          };
          this.bsModalRef = this.modalService.show(S3AdminPortalAuditTrailComponent, { initialState, backdrop: 'static', class: 'modal-xl' });
      } else {
        this.alertService.error('No Audit Trail to display.');
      }
      this.loader.hide();
    }, (error) => {
      console.log('There was an error retrieving auditTrailLog records');
      this.loader.hide();
      this.alertService.error('There was an error retrieving auditTrailLog records');
    });
  }

  public columnDefs: ColDef[] = [
    {
      field: 'dateModified',
      minWidth: 250,
      comparator: (d1, d2) => {
        return new Date(d1).getTime() < new Date(d2).getTime() ? -1 : 1;
      },
      valueFormatter: (params) => {
        return params.value
          ? moment(params.value).format('MM/DD/YYYY')
          : '-';
      }
    },
    {
      field: 'size',
      valueFormatter: (params) => {
        return (params.data.filePath.includes('.')) ? 
          (this.bytesConvertion(params.data.size)) : '';
      },
    },
    {
      field: 'Download',
      cellRenderer: DownloadButtonRendererComponent,
      cellRendererParams: {
        onClick: this.onDownloadFile.bind(this)
      }
    },
  ];

  bytesConvertion(x: any){
    const units = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    let l = 0, n = parseInt(x, 10) || 0;
    while(n >= 1024 && ++l){
        n = n/1024;
    }
    return(n.toFixed(n < 10 && l > 0 ? 1 : 0) + ' ' + units[l]);
  }

  createForm() {
    this.s3protalFormControl = this.fb.group({
      searchPrefix: new UntypedFormControl(''),
      existingPath: new UntypedFormControl(''),
      key: new UntypedFormControl(''),
      existingUploadPath: new UntypedFormControl('')
    });
  }

  getData() {
    this.loader.show();
    this.awsSimpleServiceService.getAllS3Data().subscribe(
      (data: any) => {
        this.rowData = data;
        this.loader.hide();
      }, (err: any) => {
        this.loader.hide();
        this.alertService.error('Error while retrieving S3 data.');
      }
    );
  }

  onDownloadFile(selectedFile: any) {
    this.loader.show();
    const fileName = selectedFile.parsePath[selectedFile.parsePath.length - 1];
    this.awsSimpleServiceService.downloadByObjectKey(selectedFile.filePath).subscribe(
      {
        next: (data: any) =>  {
          this.loader.hide();
          FileSaver.saveAs(data, fileName);
        },
        error: (err) => { 
          this.loader.hide();
          this.alertService.error('Error while downloading S3 data.');
         }
      });
  }

  addNewGroup() {
    const newGroupData = [
      {
        id: getNextId(),
        parsePath: ['Music', 'wav', 'hit_' + new Date().getTime() + '.wav'],
        dateModified: 'Aug 23 2017 11:52:00 PM',
        size: 58.9,
      },
    ];
    this.gridApi.applyTransaction({add: newGroupData});
  }

  handleFileInput(e: any) {
    this.fileToUpload = e.target.files[0] ? e.target.files[0] : null;
  }

  removeSelected() {
    const selectedNode = this.gridApi.getSelectedNodes(); // single selection
    if (!selectedNode) {return;}
    const arrKey: Array<String> = [];
    for (const aNode of selectedNode) {
      arrKey.push(aNode.data.filePath);
    }
    this.onRemovingObjects(arrKey, selectedNode);
  }

  onRemovingObjects(arrKeys: any, selectedNode: any) {
    this.loader.show();
    this.awsSimpleServiceService.removeObjects(arrKeys).subscribe(
      (data:any) => {
        this.loader.hide();
        if (data === true) {
          for (const aNode of selectedNode) {
            this.gridApi.applyTransaction({remove: getRowsToRemove(aNode)});
          }
        } else {
          this.alertService.error('Error while deleting S3 data.');
        }
      }, (err:any) => {
        this.loader.hide();
        this.alertService.error('Error while deleting S3 data.');
      }
    );
  }

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
  }

  searchByPrefix() {
    const searchPrefix = this.s3protalFormControl.controls['searchPrefix'].value;
    this.loader.show();
    this.awsSimpleServiceService.searchByPrefix(searchPrefix).subscribe(
      (data: any) => {
        this.loader.hide();
        this.rowData = data;
      }, (err: any) => {
        this.loader.hide();
        this.alertService.error('Error while getting S3 data');
      }
    );
  }

  createEmptyObject() {
    this.loader.show();
    const fullPath = this.s3protalFormControl.controls['existingPath'].value + '/' + this.s3protalFormControl.controls['key'].value;
    this.awsSimpleServiceService.createEmptyFolder(fullPath).subscribe(
      (data: any) => {
        this.alertService.success(data);
        this.loader.hide();
        this.getData();
      }, (err: any) => {
        this.loader.hide();
        this.alertService.error('Error while creating S3 object');
      }
    );
  }

  onUploadFile() {
    this.loader.show();
    const keyPath = this.s3protalFormControl.controls['existingUploadPath'].value;
    this.awsSimpleServiceService.uploadFile(this.fileToUpload, keyPath).subscribe(
      (result: any) => {
        this.getData();
        this.loader.hide();
      }, (err: any) => {
        this.loader.hide();
        this.alertService.error('Error while uploading data.');
      }
    );
  }

  onSelectionChanged(event: any) {
    const selectedRows = this.gridApi.getSelectedRows();
    console.log(selectedRows);
    const extPath = selectedRows[0].filePath;
    if (!selectedRows[0].filePath.includes('.')) {
      this.s3protalFormControl.controls['existingPath'].setValue(extPath);
      this.s3protalFormControl.controls['existingUploadPath'].setValue(extPath);
    }
  }

  public getDataPath: GetDataPath = (data: any) => {
    return data.parsePath;
  }
  public getRowId: GetRowNodeIdFunc = (params: any) => {
    return params.id;
  }
}

function getNextId() {
  if (!window.nextId) {
    window.nextId = 15;
  } else {
    window.nextId++;
  }
  return window.nextId;
}

function getFileCellRenderer() {
  class FileCellRenderer implements ICellRendererComp {
    eGui: any;

    init(params: ICellRendererParams) {
      const tempDiv = document.createElement('div');
      const value = params.value;
      const icon = getFileIcon(params.value);
      tempDiv.innerHTML = icon
        ? ('<span> <svg class="usa-icon" aria-hidden="true" focusable="false" role="img"> <use xlink:href="/assets/uswds/img/sprite.svg#'+icon + '"></use></svg> ' + value + ' </span>')
        : (value);
      this.eGui = tempDiv.firstChild;
    }

    getGui() {
      return this.eGui;
    }

    refresh() {
      return false;
    }
  }

  return FileCellRenderer;
}

function getRowsToRemove(node: RowNode) {
  let res: any[] = [];
  const children = node.childrenAfterGroup || [];
  for (let i = 0; i < children.length; i++) {
    res = res.concat(getRowsToRemove(children[i]));
  }
  // ignore nodes that have no data, i.e. 'filler groups'
  return node.data ? res.concat([node.data]) : res;
}

function getFileIcon(name: string) {
    return  name.indexOf(".") > -1 ? null : 'folder';
}